import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class SpecialtyVehicleBoatPurchaseSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <g>
            <path
              className={css(styles.actionAccent)}
              d="M37.361,38.461a1.824,1.824,0,1,0-1.823-1.823A1.823,1.823,0,0,0,37.361,38.461Zm1.247-9.583,6.361,6.253a1.465,1.465,0,0,1,0,2.1l-6.361,6.254a1.569,1.569,0,0,1-1.1.444H12.467a1.518,1.518,0,0,1-1.541-1.495V29.929a1.519,1.519,0,0,1,1.541-1.5H37.511A1.565,1.565,0,0,1,38.608,28.878ZM23.443,39.144c-.674-.181-1.123-.614-1.123-1.054a.684.684,0,1,0-1.367,0,2.709,2.709,0,0,0,2.49,2.451v.411a.684.684,0,1,0,1.367,0v-.41A2.7,2.7,0,0,0,27.3,38.09a2.7,2.7,0,0,0-2.49-2.452V33.383c.675.179,1.123.612,1.123,1.056a.684.684,0,1,0,1.367,0,2.7,2.7,0,0,0-2.49-2.453v-.575a.684.684,0,1,0-1.367,0v.575a2.7,2.7,0,0,0-2.49,2.453,2.7,2.7,0,0,0,2.49,2.451Zm1.367,0V37.034c.675.179,1.123.612,1.123,1.056S25.485,38.966,24.81,39.145Zm-1.367-5.762v2.111c-.675-.179-1.123-.612-1.123-1.055S22.768,33.562,23.443,33.383Z"
            />
            <path
              className={css(styles.grey)}
              d="M37.545,37.207A.773.773,0,0,1,37.7,35.67c.1.01.285.034.535.072.411.064.867.15,1.357.261a19.891,19.891,0,0,1,4.121,1.4,11.325,11.325,0,0,1,4.862,4.032,19.176,19.176,0,0,0-1.948-.04,10.7,10.7,0,0,0-3.573-2.6,18.418,18.418,0,0,0-3.8-1.288c-.455-.1-.876-.182-1.253-.241C37.778,37.234,37.622,37.215,37.545,37.207Z"
            />
          </g>
          <path
            className={css(styles.actionAccent)}
            d="M30.051,74.085a14.347,14.347,0,0,0,4.136,5.282,9.985,9.985,0,0,0,6.3,2.241c8.167.052,32,.518,43.59-1.99,1.209-.262,2.068-1.878,2.068-3.116h0Z"
          />
          <path
            className={css(styles.action)}
            d="M30.183,74.075l15.262-1.191,2.09-.186s5.257-.438,9.342-.384A13.109,13.109,0,0,1,62.2,73.522l.2.094,20.2,2.112,3.595.753S40.007,75.085,30.183,74.075Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="31.843"
            y="45.278"
            width="55.386"
            height="1.294"
            rx="0.642"
            transform="translate(100.552 -17.093) rotate(85.413)"
          />
          <path
            className={css(styles.grey)}
            d="M43.42,81.681s10.1.106,13.846-1.765a12.058,12.058,0,0,1,11.294.063c3.573,1.872,4.806-1.169,8.039.192.842.355,2.775.418,6.955-1.4,2.488-1.084,3.986-1.777,5.1-.34,1.191,1.531-.553,3.148-.553,3.148Z"
          />
          <path
            className={css(styles.action)}
            d="M41.066,63.916c1.831-.563,6.524-1.4,15.862.153-5.632-27.554-2.6-41.449-2.6-41.449C48.83,29.365,43.365,53,41.066,63.916Z"
          />
          <path
            className={css(styles.action)}
            d="M57.126,65.009c-10.541-1.794-15.132-.5-16.275-.068-.589,2.832-.92,4.588-.92,4.588H58.119C57.76,67.98,57.434,66.481,57.126,65.009Z"
          />
          <path
            className={css(styles.grey)}
            d="M80.4,64c-6.089-8.79-17.53-26.143-20.532-36.572l3.476,36.826C65.168,64.364,74.775,64.9,80.4,64Z"
          />
          <path
            className={css(styles.grey)}
            d="M80.962,64.807a57.167,57.167,0,0,1-9.272.605c-3.719,0-7.067-.184-8.262-.258l.407,4.307H84.27S82.969,67.686,80.962,64.807Z"
          />
        </g>
      </svg>
    );
  }
}
